function openTabFeed(evt, sectionId, tabName) {
  // get all elements with class="tabcontent" and hide them except the first one
  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // get all elements with class="tablinks" and remove the class "active" except the first one
  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(
      " active",
      ""
    );
  }

  // show the current tab, and add an "active" class to the button that opened the tab
  const opened = document.getElementById(tabName);
  opened.style.display = "block";
  evt.currentTarget.className += " active";

  // Every tab's slider answers the same pair of arrows, so a click in one tab
  // moves them all, and a tab opened afterwards would start part-way along.
  // Each tab opens on its first products instead. The opened one goes last
  // and is re-measured (it may never have been on screen), so the arrows end
  // up showing its state.
  const sliders = [...tabcontent]
    .filter((el) => el !== opened)
    .concat(opened)
    .map((el) => el.querySelector("swiper-component"));

  sliders.forEach((slider) => {
    const swiper = slider && slider.swiper;
    if (!swiper) return;

    if (opened.contains(slider)) swiper.update();
    swiper.slideTo(0, 0);
    if (opened.contains(slider) && swiper.navigation) swiper.navigation.update();
  });
}

// show the first tabs by default on load - data-default-open
document.querySelectorAll("[data-default-open]").forEach(el => {
  el.click();
});
window.addEventListener("shopify:section:load", () => {
  document.querySelectorAll("[data-default-open]").forEach(el => {
    el.click();
  });
});
